import React from 'react';

const Imagen = ({ 
  webpDesktopSrc, 
  pngDesktopSrc, 
  webpMobileSrc, 
  pngMobileSrc, 
  alt, 
  className,
  width, 
  height,
  loading,
  dataAnimation
}) => {
  return (
    <picture>
      <source srcSet={webpDesktopSrc} media="(min-width: 768px)" type="image/webp" />
      <source srcSet={webpMobileSrc} media="(max-width: 767px)" type="image/webp" />
      <source srcSet={pngMobileSrc} media="(max-width: 767px)" type="image/png" />
      <img src={pngDesktopSrc} alt={alt} className={className} width={width} height={height} data-aos={dataAnimation} loading={loading} />
    </picture>
  );
};

export default Imagen;
